export const BILLING_CRITICAL_FRACTION = 0.75;
